<template>
  <div v-if="moduleSettings">

    <form class="p-4 md:p-5" :id="modSettId" @submit.prevent="saveSettings()"
          @keydown.enter.prevent>


      <div v-for="(item, index) in formSchema" :key="item.name + '-'+ index" class=" py-2">

<!-- textové a dekorační prvky       -->
        <h2 v-if="item.type === 'headline'" class="text-lg font-semibold text-gray-900 dark:text-white">{{ item.label }}</h2>

        <p v-else-if="item.type === 'description'" class="text-sm text-gray-700 dark:text-white">{{ item.label }}</p>

        <hr v-else-if="item.type === 'divider'"/>

        <TextInputModuleForm v-else-if="item.type === 'text'" :id="item.name" v-model="moduleSettings[item.name]"
                             :label="item.label" :required="item.required"/>

        <TextareaInputModuleForm v-else-if="item.type === 'textarea'" :id="item.name"
                                 v-model="moduleSettings[item.name]" :label="item.label" :required="item.required"/>

        <SelectInputModuleForm v-else-if="item.type === 'select'" :id="item.name" v-model="moduleSettings[item.name]"
                               :label="item.label" :options="item.options" :required="item.required"/>


        <CheckboxInputModuleForm v-else-if="item.type === 'checkbox'" v-model="moduleSettings[item.name]"
                                 :label="item.label"/>

        <DateInputModuleForm v-else-if="item.type === 'date'" :id="item.name" v-model="formattedDate"
                             :label="item.label" :required="item.required"/>

        <FormGroupModuleForm v-else-if="item.type === 'form-group'" :label="item.label" :multiple="item.multiple"
                              :inputs="item.inputs" v-model="moduleSettings[item.name]">
          <template v-slot="{ inputs, groupIndex  }">
            <!-- Dynamické renderování vstupů ve skupině -->

            <div v-for="(subItem, i) in inputs" :key="i" class="mb-4">
              <!-- Podmínky pro typ vstupu (stejné jako výše) -->


              <TextInputModuleForm v-if="subItem.type === 'text'" :id="subItem.name"
                                   v-model="moduleSettings[item.name][groupIndex][subItem.name]"
                                   :label="subItem.label" :required="subItem.required"/>

              <TextareaInputModuleForm v-else-if="subItem.type === 'longText'" :id="subItem.name"
                                       v-model="moduleSettings[item.name][groupIndex][subItem.name]"
                                       :label="subItem.label"
                                       :required="subItem.required"/>
              <SelectInputModuleForm v-else-if="subItem.type === 'select'" :id="subItem.name"
                                     v-model="moduleSettings[item.name][groupIndex][subItem.name]"
                                     :label="subItem.label" :options="subItem.options" :required="subItem.required"/>
              <CheckboxInputModuleForm v-else-if="subItem.type === 'checkbox'"
                                       v-model="moduleSettings[item.name][groupIndex][subItem.name]"
                                       :label="subItem.label"/>
              <DateInputModuleForm v-else-if="subItem.type === 'date'" :id="subItem.name"
                                   v-model="moduleSettings[item.name][groupIndex][subItem.name]"
                                   :label="subItem.label" :required="subItem.required"/>
            </div>
          </template>

        </FormGroupModuleForm>


        <!--
                    <select v-else-if="item.type === 'select-entity'"
                            :id="key"
                            v-model="moduleSettings[item.name].selected"
                            @change="checkChanges" required>
                      <option v-for="option in item.options" :value="option">
                        {{ option[item.options.value] }}
                      </option>
                    </select>
        -->

      </div>


      <div v-if="hasUnsavedChanges" class="text-red-500">
        Máte neuložené změny!
      </div>
      <button type="submit"
              class="text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
        Uložit
      </button>
    </form>
    <!-- BTN for uninstall module    -->
    <button @click="uninstallModule(modSettId)"
            class="mt-4 bg-red-700 text-white text-sm px-4 py-2 rounded-lg shadow transition duration-200 hover:bg-red-600">
      Odinstalovat
    </button>
  </div>
</template>


<script lang="ts">


import {useAppStore} from "@/stores/appStore";
import {useNotificationStore} from "@/stores/notificationStore";
import TextInputModuleForm from "@/components/forms/moduleSettingsForm/inputs/TextInputModuleForm.vue";
import type {ModuleFormInput} from "@haxo-cz/tsoa-modules";
import TextareaInputModuleForm from "@/components/forms/moduleSettingsForm/inputs/TextareaInputModuleForm.vue";
import SelectInputModuleForm from "@/components/forms/moduleSettingsForm/inputs/SelectInputModuleForm.vue";
import CheckboxInputModuleForm from "@/components/forms/moduleSettingsForm/inputs/CheckboxInputModuleForm.vue";
import DateInputModuleForm from "@/components/forms/moduleSettingsForm/inputs/DateInputModuleForm.vue";
import FormGroupModuleForm from "@/components/forms/moduleSettingsForm/inputs/FormGroupModuleForm.vue";

export default {
  name: "moduleSettingsForm",
  components: {
    FormGroupModuleForm,
    DateInputModuleForm,
    CheckboxInputModuleForm, SelectInputModuleForm, TextareaInputModuleForm, TextInputModuleForm
  },
  props: {
    module: {
      type: Object,
      required: true
    }

  },
  data() {

    return {
      notificationStore: useNotificationStore(),
      modSettId: '',
      moduleSettings: null,
      originalSettings: null,

      formSchema: [] as ModuleFormInput[],
      hasUnsavedChanges: false,
      appStore: useAppStore()
    }
  },

  mounted() {
    console.log(this.module)

    this.getModuleSettings()
    console.log('mounted')
    console.log(this.moduleSettings)
  },

  methods: {

    async saveSettings() {
      console.log('saveSettings')

      await this.updateModuleSettings()


    },

    async uninstallModule(settingsId: string) {
      if (!confirm('Opravdu chcete odinstalovat modul?')) return;
      await this.$modulesSettingsApi.uninstallModule(this.appStore.selectedProject.spaceId, this.appStore.selectedProject._id, settingsId).then(response => {
        console.log(response);
        if (response.status === 204) {
          this.notificationStore.success('Modul byl odinstalován')

          // force refresh page with reload - beacuse of the module is uninstalled and the page is not rerendered
          location.reload()


        }
      });
    },

    async getModuleSettings() {

      await this.$modulesSettingsApi.getModule(this.appStore.selectedProject.spaceId, this.appStore.selectedProject._id, this.module.name).then(response => {
        console.log(response.data);
        this.moduleSettings = response.data.projectSettings;
        this.formSchema = (response.data.formSchema as ModuleFormInput[]);
        this.originalSettings = JSON.parse(JSON.stringify(response.data.projectSettings)); // Deep copy to compare changes
        this.modSettId = response.data.settingsId;
        console.log('moduleSettings');
        console.log(this.moduleSettings); // Debugging moduleSettings
        console.log(this.formSchema); // Debugging formSchema
        this.formSchema.forEach(item => {
          if (item.type === 'select') {
            console.log(item.name, item.options); // Debugging select options
          }
        });
      });
    },
    async updateModuleSettings() {
      await this.$modulesSettingsApi.updateModuleSettings(this.appStore.selectedProject.spaceId,
          this.appStore.selectedProject._id, this.modSettId, {projectSettings: this.moduleSettings}).then(response => {
        console.log(response);
        if (response.status === 200) {
          this.notificationStore.success('Nastavení bylo uloženo')
          this.originalSettings = JSON.parse(JSON.stringify(this.moduleSettings)); // Update original settings after save
          this.hasUnsavedChanges = false;
        }
        if (response.status !== 200) {
          console.log('error')
          this.getModuleSettings()

        }

      });
    },
    checkChanges() {
      console.log('checkChanges')
      console.log(this.moduleSettings)
      this.hasUnsavedChanges = JSON.stringify(this.moduleSettings) !== JSON.stringify(this.originalSettings);
    }
  },
  computed: {
    formattedDate: {
      get(this: { moduleSettings: { dateFrom: Date | string | null } }) {
        if (typeof this.moduleSettings.dateFrom === 'string')
          this.moduleSettings.dateFrom = new Date(this.moduleSettings.dateFrom);
        if (!this.moduleSettings.dateFrom) return '';
        const date = new Date(this.moduleSettings.dateFrom);
        const offset = date.getTimezoneOffset();
        const localISOTime = new Date(date.getTime() - (offset * 60 * 1000)).toISOString().slice(0, 16);
        return localISOTime;
      },
      set(this: { moduleSettings: { dateFrom: Date | null } }, value: string) {
        this.moduleSettings.dateFrom = value ? new Date(value) : null;
      },
    },
  }
}
</script>

<style scoped>

</style>